import service from '@/utils/request';

// 筛选项
export function getChatTypes(data) {
  return service({
    url: '/v1/chat/chatTypes',
    method: 'get',
    params: data
  })
}
// 获取会话历史，不包含详细对话
export function getHistoryList(data) {
  return service({
    url: '/v1/chat/chats',
    method: 'get',
    params: data
  })
}
// 新增意见或建议
export function addFeedback(data) {
  return service({
    url: '/v1/feedback/add',
    method: 'post',
    data
  })
}
// 新增意见或建议
export function addFeedback1(data) {
  return service({
    url: '/v1/feedback/taskAdd',
    method: 'post',
    data
  })
}
// deleteChatByUuid
export function deleteChatByUuid(data) {
  return service({
    url: '/v1/chat/deleteChatByUuid',
    method: 'delete',
    params: data
  })
}
// 重命名历史记录
export function renameHistory(data) {
  return service({
    url: '/v1/chat/rename',
    method: 'post',
    data
  })
}



// 获取我收藏的/我发布的
export function getMyResource(data) {
  return service({
    url: '/v1/design/getMyResource',
    method: 'get',
    params: data
  })
}


// 收藏、浏览、点赞、重命名操作
export function operateDesign(data) {
  return service({
    url: '/v1/design/operateDesign',
    method: 'get',
    params: data
  })
}


// 取消收藏、删除、取消点赞
export function cancelDesign(data) {
  return service({
    url: '/v1/design/cancelDesign',
    method: 'get',
    params: data
  })
}


// 查询发布的资源列表
export function getDesignPage(data) {
  return service({
    url: '/v1/design/getDesignPage',
    method: 'post',
    data: data
  })
}


// 去编辑发布
export function editRelease(data) {
  return service({
    url: '/v1/design/editRelease',
    method: 'get',
    params: data
  })
}


// 自动保存
export function autoSave(data) {
  return service({
    url: '/v1/design/autoSave',
    method: 'post',
    data: data
  })
}



// 公开发布 返回发布后的资源ID 0表示发布失败
export function publicRelease(data) {
  return service({
    url: '/v1/design/publicRelease',
    method: 'get',
    params: data
  })
}


// 获取历史版本集合(目前定的是默认查询前10条即可)
export function getHistoryRecord(data) {
  return service({
    url: '/v1/design/getHistoryRecord',
    method: 'get',
    params: data
  })
}


// 获取版本信息
export function getVersionInfo(data) {
  return service({
    url: '/v1/design/getVersionInfo',
    method: 'get',
    params: data
  })
}



// 将版本转换为word文档
export function versionToWord(data) {
  return service({
    url: '/v1/word/versionToWord',
    method: 'get',
    params: data
  })
}


// 下载PPT
export function versionToPPT(data) {
  return service({
    url: '/v1/word/versionToPPT',
    method: 'get',
    params: data
  })
}



// 退出保存版本
export function quitSave(data) {
  return service({
    url: '/v1/design/quitSave',
    method: 'POST',
    data: data
  })
}


// 获取文档是否生成过PPT，返回空串表示未生成,非空串
export function getVersionUUId(data) {
  return service({
    url: '/v1/design/getVersionUUId',
    method: 'get',
    params: data
  })
}


// 获取chat的UUId
export function getChatUUId(data) {
  return service({
    url: '/v1/design/getChatUUId',
    method: 'get',
    params: data
  })
}


// 获取标签选项列表
export function writingGetTagOptions(data) {
  return service({
    url: '/v1/writing/getTagOptions',
    method: 'get',
    params: data
  })
}